import { NavLink } from 'react-router-dom'
import { ListTodo, Users, Settings as SettingsIcon } from 'lucide-react'
import Avatar from './Avatar.jsx'
import UsageChip from './UsageChip.jsx'
import { useAuth } from '../../contexts/AuthContext.jsx'

const linkBase = 'rounded-lg px-3 py-1.5 text-[13px] text-muted hover:text-ink'
const linkActive = 'bg-line/60 font-medium text-ink'

const iconBase = 'flex h-10 w-10 items-center justify-center rounded-lg text-muted hover:text-ink'
const iconActive = 'bg-line/60 text-ink'

export default function TopNav({ cabinetName = 'Cabinet' }) {
  const { usage } = useAuth()
  return (
    <nav className="flex h-14 items-center justify-between border-b border-line bg-white px-4 sm:px-6">
      <div className="flex items-center gap-3 sm:gap-6">
        <div className="flex items-center gap-2.5 font-semibold tracking-tight">
          <span className="relative h-[22px] w-[22px] rounded-md bg-gradient-to-br from-ink to-[#3a2a1a]">
            <span className="absolute inset-[5px] rounded-sm bg-terra-500" />
          </span>
          Clarity
        </div>
        <div className="flex gap-0.5 sm:hidden">
          <NavLink to="/" end aria-label="Séances" title="Séances" className={({ isActive }) => `${iconBase} ${isActive ? iconActive : ''}`}>
            <ListTodo size={18} strokeWidth={1.8} />
          </NavLink>
          <NavLink to="/clients" aria-label="Clients" title="Clients" className={({ isActive }) => `${iconBase} ${isActive ? iconActive : ''}`}>
            <Users size={18} strokeWidth={1.8} />
          </NavLink>
          <NavLink to="/settings" aria-label="Réglages" title="Réglages" className={({ isActive }) => `${iconBase} ${isActive ? iconActive : ''}`}>
            <SettingsIcon size={18} strokeWidth={1.8} />
          </NavLink>
        </div>
        <div className="hidden gap-1 text-[13px] sm:flex">
          <NavLink to="/" end className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ''}`}>Séances</NavLink>
          <NavLink to="/clients" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ''}`}>Clients</NavLink>
          <NavLink to="/settings" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ''}`}>Réglages</NavLink>
        </div>
      </div>
      <div className="flex items-center gap-3 text-[13px]">
        <UsageChip usage={usage} />
        <span className="hidden text-muted sm:inline">{cabinetName}</span>
        <Avatar />
      </div>
    </nav>
  )
}
